module.exports = __webpack_public_path__ + "img/37.6887878a.jpg";